import { useState, useMemo } from "react";

const useMutualFundCalculator = () => {

    const [investment, setInvestment] = useState(100000);
    const [rate, setRate] = useState(12);
    const [years, setYears] = useState(10);

    const { totalValue, investedAmount, estimatedReturns } = useMemo(() => {

        if (investment <= 0 || rate <= 0 || years <= 0) {
            return {
                totalValue: 0,
                investedAmount: 0,
                estimatedReturns: 0
            };
        }

        const futureValue =
            investment * Math.pow(1 + rate / 100, years);

        return {
            totalValue: futureValue,
            investedAmount: investment,
            estimatedReturns: futureValue - investment
        };

    }, [investment, rate, years]);

    return {
        title: "Mutual Fund Returns Calculator",

        inputs: [
            {
                label: "Total Investment",
                value: investment,
                setter: setInvestment,
                min: 1000,
                max: 10000000,
                step: 1000,
            },
            {
                label: "Expected Return Rate (p.a)",
                value: rate,
                setter: setRate,
                min: 1,
                max: 30,
                step: 0.5,
            },
            {
                label: "Time Period (Years)",
                value: years,
                setter: setYears,
                min: 1,
                max: 40,
                step: 1,
            },
        ],

        totalValue,
        investedAmount,
        estimatedReturns,

        infoContent: {
            heading: "Mutual Fund Calculator",
            description:
                "A Mutual Fund calculator helps you estimate the potential returns on your investment based on expected annual return and duration.",

            subHeading1: "What is a Mutual Fund Calculator?",
            subContent1:
                "It calculates the future value of your investment using compound interest to estimate total growth over time.",

            subHeading2: "How It Works",
            subContent2:
                "Based on invested amount, annual return rate, and time period, it estimates the total value and profit earned.",

            formula: "M = P × (1 + r)^n",

            subHeading3: "Benefits",
            benefits: [
                "Estimates future investment value",
                "Supports financial goal planning",
                "Quick and accurate calculations",
                "Useful for long-term wealth building",
            ],
        }
    };
};

export default useMutualFundCalculator;